/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();